import React, { Component } from 'react';

import {IQala} from './IQala';
import {IKomek} from './IKomek';

import { CaseMainTitle } from '../../components/newDesign/CaseMainTitle';
import { MainWrapper } from '../../components/newDesign/MainWrapper/MainWrapper';
import { RadioGroup } from '../../components/newDesign/RadioGroup';

const tabs = [
    {
        name: 'iQala',
    },
    {
        name: 'iKomek',
    },
];

const NAME_COMP = {
    'iQala': <IQala />,
    'iKomek': <IKomek />,
};

class Social2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            radio: Object.keys(NAME_COMP)[0],
        };
    }

    radioChange = (value) => {
        this.setState({
            radio: value.target.value,
        });
    };

    render() {
        return (
            <MainWrapper>
                <CaseMainTitle>Обращения граждан</CaseMainTitle>
                <RadioGroup
                    onChange={this.radioChange}
                    value={this.state.radio}
                    list={tabs.map((i) => ({
                        key: i.name,
                        value: i.name,
                    }))}
                />
                {Object.keys(NAME_COMP).map((nav) => {
                    if (nav === this.state.radio) return NAME_COMP[nav];
                    else return null;
                })}
            </MainWrapper>
        );
    }
}

export default Social2;
